import type { SectionItem } from '@/types/components/section-item'

export const INSTALLATION_SECTION_ITEMS: SectionItem[] = [
	{
		id: 'mainline-construction',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-directional-boring-car.avif',
			alt: 'Maverix Fiber-fast internet',
			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	},
	{
		id: 'home-site-survey',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-site-survey.avif',
			alt: 'Maverix Fiber-fast internet',
			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	},
	{
		id: 'yard-trenching',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-plow.avif',
			alt: 'Maverix Fiber-fast internet',
			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	},
	{
		id: 'interior-home-installation',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-inside-install.avif',
			alt: 'Maverix Fiber-fast internet',
			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	},
	{
		id: 'fiber-splicing',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-fiber-splicing.avif',
			alt: 'Maverix Fiber-fast internet',

			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	},
	{
		id: 'online-activation',
		viewbox: {
			width: 200,
			height: 300
		},
		image: {
			url: '/images/maverix-broadband-activation.avif',
			alt: 'Maverix Fiber-fast internet',
			height: 212,
			width: 300
		},
		lines: [],
		circles: []
	}
]
